import { NetworkCookie } from './../../cookie/NetworkCookie';
import {BasicAchievementData} from "./components/BasicAchievementData";
import {AgeGateData} from "./components/AgeGateData";
import {BasicFontData} from "./components/BasicFontData";
import {BasicIdentityManagementData} from "./components/BasicIdentityManagementData";
import {BasicLanguageData} from "./components/BasicLanguageData";
import {BasicLoaderData} from "./components/BasicLoaderData";
import {BasicLocalizationData} from "./components/BasicLocalizationData";
import {BasicSessionData} from "./components/BasicSessionData";
import {BasicSharedObject} from "./components/BasicSharedObject";
import {BasicSmartfoxClient} from "./components/BasicSmartfoxClient";
import {BasicUserData} from "./components/BasicUserData";
import {ForumData} from "./components/forum/ForumData";
import {BasicSocialData} from "./components/social/BasicSocialData";
import {InstanceVOProxy} from "./proxy/InstanceVOProxy";
import {BranchesModel} from "./instance/BranchesModel";

export class BasicModel {
    // TODO: Put instances to networkData
    public static instanceProxy: InstanceVOProxy = new InstanceVOProxy();
    private static _forumData: ForumData;
    protected static _smartfoxClient: BasicSmartfoxClient;
    protected static _userData: BasicUserData;
    protected static _socialData: BasicSocialData;
    protected static _languageData: BasicLanguageData;
    protected static _fontData: BasicFontData;
    protected static _achievementData: BasicAchievementData;
    protected static _localData: BasicSharedObject;
    protected static _networkCookie: NetworkCookie = new NetworkCookie();
    protected static _sessionData: BasicSessionData;
    protected static _basicLoaderData: BasicLoaderData;
    protected static _localizationData: BasicLocalizationData;
    private static _identityManagement: BasicIdentityManagementData;
    private static _ageGateData: AgeGateData;
    private static _branchesModel: BranchesModel;

    static get smartfoxClient(): BasicSmartfoxClient {
        return BasicModel._smartfoxClient;
    }

    static set smartfoxClient(value: BasicSmartfoxClient) {
        BasicModel._smartfoxClient = value;
    }

    static get userData(): BasicUserData {
        if (!BasicModel._userData) {
            BasicModel._userData = new BasicUserData();
        }
        return BasicModel._userData;
    }

    static set userData(value: BasicUserData) {
        BasicModel._userData = value;
    }

    static get socialData(): BasicSocialData {
        return BasicModel._socialData;
    }

    static set socialData(value: BasicSocialData) {
        BasicModel._socialData = value;
    }

    static get languageData(): BasicLanguageData {
        return BasicModel._languageData;
    }

    static set languageData(value: BasicLanguageData) {
        BasicModel._languageData = value;
    }

    static set fontData(value: BasicFontData) {
        BasicModel._fontData = value;
    }

    static get fontData(): BasicFontData {
        return BasicModel._fontData;
    }

    static get achievementData(): BasicAchievementData {
        return BasicModel._achievementData;
    }

    static set achievementData(value: BasicAchievementData) {
        BasicModel._achievementData = value;
    }

    public static get localData(): BasicSharedObject {
        return BasicModel._localData;
    }

    public static set localData(value: BasicSharedObject) {
        BasicModel._localData = value;
    }

    public static get networkCookie(): NetworkCookie {
        return BasicModel._networkCookie;
    }

    public static get sessionData(): BasicSessionData {
        if (!BasicModel._sessionData) {
            BasicModel._sessionData = new BasicSessionData();
        }

        return BasicModel._sessionData;
    }

    public static set sessionData(value: BasicSessionData) {
        BasicModel._sessionData = value;
    }

    public static get basicLoaderData(): BasicLoaderData {
        return BasicModel._basicLoaderData;
    }

    public static set basicLoaderData(value: BasicLoaderData) {
        BasicModel._basicLoaderData = value;
    }

    public static get basicLocalization(): BasicLocalizationData {
        if (!BasicModel._localizationData) {
            BasicModel._localizationData = new BasicLocalizationData();
        }

        return BasicModel._localizationData;
    }

    public static set basicLocalization(value: BasicLocalizationData) {
        BasicModel._localizationData = value;
    }

    public static get identityManagement(): BasicIdentityManagementData {
        return BasicModel._identityManagement;
    }

    public static set identityManagement(value: BasicIdentityManagementData) {
        BasicModel._identityManagement = value;
    }


    public static get forumData(): ForumData {
        if (!BasicModel._forumData) {
            BasicModel._forumData = new ForumData();
        }

        return BasicModel._forumData;
    }

    public static get ageGateData(): AgeGateData {
        if (!BasicModel._ageGateData) {
            BasicModel._ageGateData = new AgeGateData();
        }

        return BasicModel._ageGateData;
    }

    public static get branchesModel(): BranchesModel {
        return BasicModel._branchesModel || (BasicModel._branchesModel = new BranchesModel());
    }

}
